import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, Overlay } from "react-leaflet";

import "leaflet/dist/leaflet.css";

import mapData from "../../data/maps/south-africa-provinces.json";

import "../../styles/map.css";

const ProvinceEventsMap = ({
  data,
  hoverText,
  dataSource,
  width = "95%",
  height = "600px",

  annotatedCssContainer = "census-info-hover",
  annotatedCssText = "census-info",
}) => {
  // Centre of South Africa
  const center = [-29.4856, 26.124];

  const [onselect, setOnselect] = useState({});
  /* function determining what should happen onmouseover, this function updates our state*/

  const mapDisplayData = { ...mapData };

  const resetHighlight = (e) => {
    setOnselect({});
    e.target.setStyle(style(e.target.feature));
  };

   const highlightFeature = (e) => {
    var layer = e.target;
    const { name, NYSEvents } = e.target.feature.properties;
    setOnselect({
      name: name,
      NYSEvents: NYSEvents,
    });
    layer.setStyle(highlightStyle);
  };

  const highlightStyle = {
    weight: 1,
    color: "black",
    fillOpacity: 1,
  };

  const onEachFeature = (feature, layer) => {
    layer.on({
      mouseover: highlightFeature,
      mouseout: resetHighlight,
    });
  };

  const mapPolygonColorToEvents = (numberOfEvents) => {
    return numberOfEvents > 40
      ? "#c0011d"
      : numberOfEvents > 20
      ? "#f43926"
      : numberOfEvents > 10
      ? "#ff8645"
      : numberOfEvents > 5
      ? "#fbb144"
      : numberOfEvents > 0
      ? "#ffd672"
      : numberOfEvents < 1
      ? "#f8ffb8"
      : "";
  };

  const mapPolygonColorToParticipants = (numberOfEvents) => {
    return numberOfEvents > 40
      ? "#A569BD"
      : numberOfEvents > 20
        ? "#5DADE2"
        : numberOfEvents > 10
          ? "#229954"
          : numberOfEvents > 5
            ? "#D4AC0D"
            : numberOfEvents > 0
              ? "#34495E"
              : numberOfEvents < 1
                ? "#873600"
                : "";
  };

  const style = (feature) => {
    // if (dataSource === "Participants") {
    //   return {
    //     fillColor: mapPolygonColorToParticipants(feature.properties.NYSEvents),
    //     weight: 1.5,
    //     opacity: 1,
    //     color: "white",
    //     dashArray: "2",
    //     fillOpacity: 0.75,
    //   };
    // } 
    // else 
    {
      return {
        fillColor: mapPolygonColorToEvents(feature.properties.NYSEvents),
        weight: 1.5,
        opacity: 1,
        color: "white",
        dashArray: "2",
        fillOpacity: 0.75,
      };
    }
  };

  const mapStyle = {
    // height: "590px",
    width: width,
    height: height,
    margin: "0 auto",
    zIndex: 1,
  };

  const findProvinceCount = (province) => {
    return data?.find((record) => record.type == province);
  };

  const feature = mapDisplayData.features.map((feature) => {
    const province = findProvinceCount(feature.properties.name);
    if (province) {
      feature.properties.NYSEvents = province.percent;
    } else {
      feature.properties.NYSEvents = 0;
      return null;
    }
    return feature;
  });

  return (
    <div className="province-container">
      {/* <div className="header">
       </div> */}
      <div className="">
        <div className="">
          {!onselect.name && (
            <div className={annotatedCssContainer}>
              <strong> {hoverText}</strong>
              <p>Hover on each Province for more details</p>
            </div>
          )}
          {onselect.name && (
            <ul className={annotatedCssText}>
              <li>
                <strong>{onselect.name}</strong>
              </li>
              <br />
              <li>
                Total {dataSource}:{onselect.NYSEvents}%
              </li>
            </ul>
          )}
          <MapContainer
            zoom={6}
            scrollWheelZoom={false}
            style={mapStyle}
            center={center}
            preferCanvas
          >
            {/* <TileLayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" /> */}
            {feature && (
              <GeoJSON
                data={mapDisplayData.features}
                style={style}
                onEachFeature={onEachFeature}
              />
            )}
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default ProvinceEventsMap;
